import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import {
  CriteriaTextWrapper,
  MatchStyledText,
  StyledFlexWithGapAndNoWrap,
} from './SmartChoiceBreakDown.styles';

interface NotAMatchTextProps {
  text: string | undefined;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
  noIcon?: boolean;
}
export const NotAMatchText = ({
  text,
  StartIcon,
  EndIcon,
  noIcon,
}: NotAMatchTextProps) => {
  if (!text?.trim()) {
    return null;
  }

  return (
    <CriteriaTextWrapper data-testid={`not-a-match-text-${text}`}>
      <StyledFlexWithGapAndNoWrap direction="row">
        {!noIcon && (
          <IconSymbol
            color="#990000"
            data-testid="not-a-match-icon"
            icon="block"
          />
        )}
        {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}
      </StyledFlexWithGapAndNoWrap>
      <CriteriaTextWrapper>
        <MatchStyledText
          css={noIcon ? { paddingLeft: '26px' } : {}}
          data-testid="not-a-match-text-content"
        >
          {text}
        </MatchStyledText>
        {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
      </CriteriaTextWrapper>
    </CriteriaTextWrapper>
  );
};
